export { type PronunciationHint, resolvePronunciationHint } from "#pronunciation-hint";
export {
  getTermPhoneticSpan,
  type PinyinSoundHint,
  resolvePinyinSoundHint,
} from "#pinyin-sound-hint";
